import {Post} from "../../common/types/post.types";
import Content from "./content";

function SimplePost(props: Props) {
  return <Content data={props.post.post_indexes[0].content} />
}

export default SimplePost;

class Props {
  post: Post;
}
